import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

export enum PlatformType {
  BROWSER = 'browser',
  SERVER = 'server'
}

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  private readonly browserEnv: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: string) {
    this.browserEnv = isPlatformBrowser(platformId);
  }

  get isBrowser(): boolean {
    return this.browserEnv;
  }

  get isServer(): boolean {
    return !this.browserEnv;
  }
}
